import React, { useState, useEffect } from 'react';
import { Row, Col, Button, Spinner } from 'react-bootstrap';
import { PropTypes } from 'prop-types';
import { useTranslation } from 'react-i18next';

import api from './../../../api';

import PartnerMaterialItem from './PartnerMaterialItem';
import MaterialUploadModal from '../../Modals/MaterialUploadModal/MaterialUploadModal';

PartnerMaterials.propTypes = {
    eventID: PropTypes.string.isRequired,
    partnerID: PropTypes.string.isRequired,
    uploadsBaseUrl: PropTypes.string
};

function PartnerMaterials(props) {
    const { t } = useTranslation();
    const { eventID, partnerID, uploadsBaseUrl } = props;

    const [ showModal, setShowModal ] = useState(false);
    const [ files, setFiles ] = useState([]);
    const [ loading, setLoading ] = useState(true);


    /**
     * Download material.
     *
     * @param {string} materialID
     */
    const _downloadMaterial = materialID => {
        const url = `${uploadsBaseUrl}/uploads/materials/${eventID}/${materialID}`;
        window.open(url, '_blank');
    }


    /**
     * Delete material.
     *
     * @param {int} eventsPartnersFileId
     * @param {function} callback
     */
    const _deleteMaterial = (eventsPartnersFileId, callback) => {
        api.material.deletePartnersEventFile(partnerID, eventsPartnersFileId).then(response => {
            if(callback) {
                callback();
            }
        })
    }


     /**
     * Material upload callback.
     *
     * @param {object} material
     */
    const _materialUploadCallback = material => {
        const fileData = {
            materialID: material.materialID,
            name: material.originalFileName
        }
        api.material.uploadPartnersEventFile(eventID, partnerID, fileData).then(response => {
            _fetchMaterials();
        });
    }


    /**
     * Fetch materials.
     */
    const _fetchMaterials = React.useCallback(() =>  {
        api.material.getPartnersEventFiles(eventID, partnerID).then(response => {
            setFiles(response.data.data.eventsPartnersFiles)
        }).finally(() => {
            setLoading(false);
        });
    }, [eventID, partnerID]);


    /**
     * Fetch partner's event materials on compnent mount.
     */
    useEffect(() => {
       _fetchMaterials();
    }, [_fetchMaterials]);


    return (
        <React.Fragment>
            <Row>
                <Col className="text-right" style={{ borderBottom: '1px solid #F0F0F0', marginBottom: '20px', paddingBottom: '20px' }}>
                    {loading &&
                        <Spinner animation="border" variant="primary" size="sm" className="float-left" />
                    }
                    <Button variant="primary" onClick={_fetchMaterials}>{t('general.update')}</Button>
                    <Button variant="success" style={{ marginLeft: '10px' }} onClick={() => setShowModal(!showModal)}>{t('general.upload_files')}</Button>
                </Col>
            </Row>
            {!loading ?
                files.map(file => (
                    <PartnerMaterialItem
                        file={file}
                        thumbURL={`${uploadsBaseUrl}${file.material.absolutePath}_XS`}
                        key={file.eventsPartnersFileId}
                        onDownload={_downloadMaterial}
                        onDelete={_deleteMaterial}
                    />
                ))
            :
            null}

            {!loading && files.length === 0 ?
                <span>{t('general.no_uploaded_files')}</span>
            : null}

            <MaterialUploadModal
                {...props}
                onHide={() => setShowModal(false)}
                show={showModal}
                callback={_materialUploadCallback}
                materialFolderType={15}
            />

        </React.Fragment>
    )
}


export default PartnerMaterials;